import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const SortingControls = ({ 
  sortBy = 'savedDate', 
  sortOrder = 'desc', 
  onSortChange, 
  viewMode = 'grid', 
  onViewModeChange,
  totalCount = 0 
}) => {
  const sortOptions = [
    { value: 'savedDate', label: 'Date Saved' },
    { value: 'price', label: 'Price' },
    { value: 'location', label: 'Location' },
    { value: 'bedrooms', label: 'Bedrooms' },
    { value: 'sqft', label: 'Square Feet' },
    { value: 'yearBuilt', label: 'Year Built' },
    { value: 'title', label: 'Property Name' }
  ];

  const handleSortByChange = (newSortBy) => {
    onSortChange(newSortBy, sortOrder);
  };

  const handleSortOrderToggle = () => {
    const newOrder = sortOrder === 'asc' ? 'desc' : 'asc';
    onSortChange(sortBy, newOrder);
  };

  const getSortOrderIcon = () => {
    if (sortBy === 'savedDate' || sortBy === 'price' || sortBy === 'sqft' || sortBy === 'yearBuilt') {
      return sortOrder === 'desc' ? 'ArrowDownWideNarrow' : 'ArrowUpWideNarrow';
    } else {
      return sortOrder === 'asc' ? 'ArrowUpAZ' : 'ArrowDownAZ';
    }
  };

  const getSortOrderLabel = () => {
    if (sortBy === 'savedDate') {
      return sortOrder === 'desc' ? 'Newest First' : 'Oldest First';
    } else if (sortBy === 'price' || sortBy === 'sqft') {
      return sortOrder === 'desc' ? 'High to Low' : 'Low to High';
    } else if (sortBy === 'yearBuilt') {
      return sortOrder === 'desc' ? 'Newest Built' : 'Oldest Built';
    } else {
      return sortOrder === 'asc' ? 'A to Z' : 'Z to A';
    }
  };

  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 bg-card border border-border rounded-lg">
      {/* Results Count */}
      <div className="flex items-center space-x-2">
        <Icon name="Filter" size={16} className="text-muted-foreground" />
        <span className="text-sm text-muted-foreground">
          {totalCount} {totalCount === 1 ? 'property' : 'properties'} saved
        </span>
      </div>

      {/* Sorting and View Controls */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
        {/* Sort By */}
        <div className="flex items-center space-x-2">
          <span className="text-sm font-medium text-foreground whitespace-nowrap">Sort by:</span>
          <Select
            options={sortOptions}
            value={sortBy}
            onChange={handleSortByChange}
            className="min-w-[140px]"
          />
        </div>

        {/* Sort Order */}
        <Button
          variant="outline"
          size="sm"
          iconName={getSortOrderIcon()}
          iconPosition="left"
          iconSize={14}
          onClick={handleSortOrderToggle}
          title={getSortOrderLabel()}
          className="whitespace-nowrap"
        >
          {getSortOrderLabel()}
        </Button>

        {/* View Mode Toggle */}
        <div className="flex items-center border border-border rounded-md">
          <button
            onClick={() => onViewModeChange('grid')}
            className={`p-2 rounded-l-md transition-colors ${
              viewMode === 'grid' ?'bg-primary text-primary-foreground' :'bg-card text-muted-foreground hover:text-foreground hover:bg-muted'
            }`}
            title="Grid view"
          >
            <Icon name="Grid3X3" size={16} />
          </button>
          <button
            onClick={() => onViewModeChange('list')}
            className={`p-2 rounded-r-md transition-colors ${
              viewMode === 'list' ?'bg-primary text-primary-foreground' :'bg-card text-muted-foreground hover:text-foreground hover:bg-muted'
            }`}
            title="List view"
          >
            <Icon name="List" size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SortingControls;